import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { AfterViewChecked, Component, OnInit, ViewChild } from '@angular/core';
import { SelectEvent, TabStripComponent } from '@progress/kendo-angular-layout';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';

@Component({
  selector: 'app-enrollments',
  templateUrl: './enrollments.component.html',
  styleUrls: ['./enrollments.component.css']
})
export class EnrollmentsComponent implements OnInit, AfterViewChecked {
  adminOperators: any;
  operators: any;
  editEnrollmentData: any;
  initialLoading = false;
  isHistoryDisable: boolean;
  @ViewChild('enrolltabstrip') tabstrip: TabStripComponent;

  constructor(
    private authService: AuthService,
    private readConfigService: ReadConfigService,
  ) { }

  ngOnInit(): void {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    const accessRole = this.authService.getAccessId('Enrollments');
    if (accessRole && accessRole.role === "administrator") {
      this.adminOperators = this.authService.getAccessOperations(2);
    } else {
      this.operators = this.authService.getAccessOperations(2);
    }
  }

  ngAfterViewChecked() {
    this.setTabStripStyle();
  }

  setTabStripStyle() {
    const allDetails = document.querySelectorAll('.k-tabstrip');
    if (allDetails && allDetails.length > 0) {
      allDetails.forEach(details => {
        const firstChild = details.firstElementChild.children[0];
        if (firstChild && firstChild.children && firstChild.children.length > 1) {
          const elArr = Array.from(firstChild.children) as Array<HTMLElement>;
          const tabFirstEl = Array.from(elArr[0].children) as Array<HTMLElement>;
          const tabSecEl = Array.from(elArr[1].children) as Array<HTMLElement>;
          tabFirstEl[0].style.marginRight = '5px';
          tabSecEl[0].style.marginRight = '5px';
          elArr.forEach(element => {
            element.style.width = 100 / firstChild.children.length + '%';
          });
        }
      });
    }
  }

  onSelect(e: SelectEvent): void {
    // TODO: write history click event
    // this.isHistoryDisable = (e.index === 0);
    this.getEnrollmentRecord(null);
  }

  disableHistory(value: boolean) {
    this.isHistoryDisable = value;
  }

  getEnrollmentRecord(event: any) {
    this.tabstrip.tabs.forEach(x => {
      switch (x.title) {
        case 'Enroll Member':
          x.selected = true;
          this.editEnrollmentData = event;
          break;
        case 'In-Progress/Pending':
          x.selected = false;
          break;
        case 'Processed':
          x.selected = false;
          break;
      }
    });
  }

}
